import styled from 'styled-components';

const Main = styled.main`
  margin-top: 64px;
  height: calc(100% - 64px);
  padding: 1.5rem;
  overflow-y: auto;
`;

export default Main;
